export const USERS_SET = 'USERS_SET'
export const USERS_CREATE = 'USERS_CREATE'
export const USERS_UPDATE = 'USERS_UPDATE'
export const USERS_SET_UPDATING = 'USERS_SET_UPDATING'
export const USERS_DELETE = 'USERS_DELETE'
export const USERS_RESET_PASSWORD = 'USERS_RESET_PASSWORD'
export const USERS_ACTIVATE = 'USERS_ACTIVATE'
